export const MessageRole = {
  User: 'user',
  Assistant: 'assistant',
} as const;

export type MessageRole = (typeof MessageRole)[keyof typeof MessageRole];

export const PAGE_MARGIN = 20;
export const DEFAULT_PAGE_HEIGHT = 800;
export const DEFAULT_PAGE_WIDTH = 800;

export const DEFAULT_MAX_FILES_BEFORE_WARNING = 50;

export const DEFAULT_FILE_COUNT_WARNING_MESSAGE =
  'Querying many files will take some time. Try selecting specific files to query for a faster response.';

// Citation markers. Ids can be UUIDs, numbers or strings like `{{UPLOAD_0}}`, so check the id
// against the chat's `citations` map.
export const UUID_REGEX = /{{\s*([\w-]+)\s*}}/g;

// Prefix for client-only chat document ids, not yet created on the server.
export const TEMP_LOCAL_DOCUMENT_ID_PREFIX = 'temp-local-';

export const draftChat = 'draft';

/** Trailing marker appended while the assistant response is still streaming. */
export const STREAMING_CURSOR_CHAR = '▌';

/**
 * Loading sheen cycle for placeholder citation pills, so pills stay in phase. Keep in sync with
 * `citation-pill-sheen` in `index.css`.
 */
export const CITATION_PILL_SHEEN_DURATION_MS = 4000;
